const HEX_COLOUR = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

const expandShorthand = (hex: string): string => {
  if (hex.length !== 4) return hex; // already #RRGGBB
  const [, r, g, b] = hex;
  return `#${r}${r}${g}${g}${b}${b}`;
};

/**
 * Appends an alpha channel to a 3- or 6-digit hex colour, returning an
 * 8-digit hex (#RRGGBBAA). Use for opacity-based states (e.g. hover) so
 * values stay anchored to a Clarity token rather than a hardcoded rgba().
 *
 * @param hex   3- or 6-digit hex colour, e.g. Colour.Clarity.Blue.Hard
 * @param alpha 0–1 opacity (clamped; non-finite treated as 1)
 * @throws if hex is not a 3- or 6-digit hex string
 */
export const withAlpha = (hex: string, alpha: number): string => {
  if (!HEX_COLOUR.test(hex)) {
    throw new Error(`withAlpha: expected 3- or 6-digit hex, got "${hex}"`);
  }

  const rgb = expandShorthand(hex);
  const safeAlpha = Number.isFinite(alpha) ? alpha : 1;
  const clamped = Math.min(Math.max(safeAlpha, 0), 1);
  const channel = Math.round(clamped * 255)
    .toString(16)
    .padStart(2, '0');

  return `${rgb}${channel}`;
};
